(function () {

function close_modal_cart () {
  const close_modal = document.getElementById('modal_cart');
  if (close_modal) {
    close_modal.remove();
  }
}

function render_modal_cart (root_el) {
  if (window_api_data.template_name != 'cart') {
    return;
  }
  
  if (window_api_data.country == 'SA' || window_api_data.country == 'UK' || window_api_data.country == 'EU' || window_api_data.country == 'US') {
    const bot_pattern_re = new RegExp('(Googlebot|APIs-Google|Mediapartners-Google|AdsBot-Google-Mobile|AdsBot-Google|Googlebot-Image|Googlebot-News|Googlebot-Video|AdsBot-Google-Mobile-Apps|bingbot|slurp|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|findlink|msrbot|panscient|yacybot|AISearchBot|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|Linespider)', 'i');
    try {
      const site_wide_modal_show = localStorage.getItem('modal_cart_show');
      if (site_wide_modal_show) {
        const days_since_show = (Date.now() - site_wide_modal_show) / 8.64e7;
        if (bot_pattern_re.test(navigator.userAgent)) {
          return;
        }
        if (site_wide_modal_show && days_since_show < 1) {
          return;
        }
      }
    } catch (e) {
      // private mode set
    }

    try {
      localStorage.setItem('modal_cart_show', Date.now());
    } catch (e) {
      // private mode set
    }

    const site_wide_modal = document.createElement('div');
    site_wide_modal.id = 'modal_cart';
    site_wide_modal.className = 'modal_cart';
    root_el.appendChild(site_wide_modal);

    const site_wide_modal_content = document.createElement('div');
    site_wide_modal_content.className = 'modal_cart_content';
    if (window_api_data.country == 'SA') {
      site_wide_modal_content.innerHTML = `
        <p><strong>South American Customers</strong></p>
        <p>Please be aware that you are responsible for paying any import taxes, duties, and customs fees that may be applied to your order.</p>
        <p>These charges are not included in the purchase price and are determined by your local customs authority.</p>
      `;
    }
    if (window_api_data.country == 'UK') {
      site_wide_modal_content.innerHTML = `
        <p><strong>UK Customers</strong></p>
        <p>Flat rate express shipping to the UK for £25.00 GBP with DHL International Express.</p>
        <p>All duties and taxes included in purchase price.</p>
      `;
    }
    if (window_api_data.country == 'EU') {
      site_wide_modal_content.innerHTML = `
        <p><strong>EU Customers</strong></p>
        <p>Flat rate express shipping to the EU for €30.00 with DHL International Express.</p>
        <p>All duties and taxes included in purchase price.</p>
      `;
    }
    if (window_api_data.country == 'US') {
      site_wide_modal_content.innerHTML = `
        <p><strong>USA Customers</strong></p>
        <p>The purchase price includes all local duties and taxes, so you wont incur any additional charges upon delivery.</p>
      `;
    }
    site_wide_modal.appendChild(site_wide_modal_content);
    
    const site_wide_close = document.createElement('div');
    site_wide_close.className = 'modal_close';
    site_wide_close.innerHTML = 'CLOSE';
    site_wide_modal_content.appendChild(site_wide_close);
    site_wide_close.addEventListener('click', close_modal_cart);

    window.addEventListener("click", function(event) {
      if (event.target == document.getElementById("modal_cart")) {
        close_modal_cart();
      }
    });
  }
}

window.render_modal_cart = render_modal_cart;

})()
